import tippy from 'tippy.js';

export const initialiseTooltips = (selector = '[data-tippy-content]') => {
  const elements =
    typeof selector === 'string' ? document.querySelectorAll(selector) : [selector].flat();

  elements.forEach((element) => {
    if (element._tippy) {
      return;
    }

    const theme = element.getAttribute('data-tippy-theme') || 'posieandpenn';
    const placement = element.getAttribute('data-tippy-placement') || 'top';
    const triggerTarget = element.getAttribute('data-tippy-trigger-target');
    const triggerTargetClosest = element.getAttribute('data-tippy-trigger-target-closest');
    const showOnCreate = element.getAttribute('data-tippy-show-on-create') === 'true';
    const isInteractive = element.getAttribute('data-tippy-interactive') === 'true';
    const allowHtml = element.getAttribute('data-tippy-allow-html') === 'true';
    const shouldNotHideOnClick = element.getAttribute('data-tippy-hide-on-click') === 'false';
    const isPositionFixed = element.getAttribute('data-tippy-position-fixed') === 'true';
    const appendTo = element.getAttribute('data-tippy-append-to') === 'parent' ? 'parent' : document.body;
    const maxWidth = Number(element.getAttribute('data-tippy-max-width')) || 350;
    const disappearDelay = parseInt(element.getAttribute('data-tippy-disappear-delay'), 10);

    tippy(element, {
      theme,
      placement,
      animation: 'shift-toward',
      showOnCreate,
      appendTo,
      maxWidth,
      interactiveBorder: 30,
      ...(allowHtml && { allowHTML: true }),
      ...(isInteractive && { interactive: true }),
      ...(shouldNotHideOnClick && { hideOnClick: false }),
      ...(disappearDelay && { delay: [null, disappearDelay] }),
      ...(triggerTarget && { triggerTarget: document.querySelector(triggerTarget) }),
      ...(triggerTargetClosest && { triggerTarget: element.closest(triggerTargetClosest) }),
      ...(isPositionFixed && {
        popperOptions: {
          strategy: 'fixed',
        },
      }),
    });
  });
};
